module.exports = __webpack_public_path__ + "img/person-lines-fill.453a3612.svg";